import { render, staticRenderFns } from "./BlockListHeading.vue?vue&type=template&id=295188e9&scoped=true&"
import script from "./BlockListHeading.vue?vue&type=script&lang=js&"
export * from "./BlockListHeading.vue?vue&type=script&lang=js&"
import style0 from "./BlockListHeading.vue?vue&type=style&index=0&id=295188e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295188e9",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/BlockListHeading.vue
// module id = null
// module chunks = 